import { useEffect, useMemo, useState } from "react";
import { ShipmentStatus } from "@api/graphql/generated/generated-types";
import { useShipmentsCoreDataContext } from "../context/ShipmentsCoreData";
import { useShipmentSelectionContext } from "../context/ShipmentSelectionContext";

interface UseBulkChangeDriversReturn {
  isChangeDriversDisabled: boolean;
  changeDriversDisabledReason: string | undefined;
}

function useBulkChangeDrivers(): UseBulkChangeDriversReturn {
  const { rows } = useShipmentsCoreDataContext();
  const { checkedShipments } = useShipmentSelectionContext();

  const [isChangeDriversDisabled, setIsChangeDriversDisabled] = useState(false);
  const [changeDriversDisabledReason, setChangeDriversDisabledReason] =
    useState<string | undefined>(undefined);

  const memoizedCheckedShipments = useMemo(
    () => checkedShipments,
    [checkedShipments]
  );

  useEffect(() => {
    var changeDriversDisabledReason: string | undefined = undefined;

    const isAllCheckedShipmentsEligibleForChange =
      memoizedCheckedShipments.every((shipmentId) => {
        const row = rows.find((row) => row?.key === shipmentId);
        if (!row) return false;

        switch (row?.shipmentStatus) {
          case ShipmentStatus.Created:
          case ShipmentStatus.Routed:
          case ShipmentStatus.InTransit:
          case ShipmentStatus.Assigned:
            return true;
          default:
            changeDriversDisabledReason =
              "Shipments must be in a valid status (Created, Routed, InTransit, or Assigned)";
            return false;
        }
      });
    setChangeDriversDisabledReason(changeDriversDisabledReason);
    setIsChangeDriversDisabled(!isAllCheckedShipmentsEligibleForChange);
  }, [memoizedCheckedShipments, rows]);

  return {
    isChangeDriversDisabled,
    changeDriversDisabledReason,
  };
}

export default useBulkChangeDrivers;
